import { Tkv2ReferenceViewModule } from '../../modules/referenceView/Tkv2ReferenceViewModule.tsx';

export const Tkv2MlsImageCarouselRouteElement = () => {
  return <Tkv2ReferenceViewModule isPopout dataSheet="mls-images" />;
};
